export { HTML5DragTransition, TouchTransition, MouseTransition } from './Transitions';
export { default as createTransition } from './createTransition';
import MultiBackend, { PreviewManager } from './MultiBackend';
export { MultiBackend, PreviewManager };
export default (function (manager, context, options) {
  return new MultiBackend(manager, context, options);
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/dnd-multi-backend/dist/esm/index.js
// module id = 533
// module chunks = 0